import { combineReducers } from "redux";
import drawnImageReducer from "./drawnImageReducer";
import imagesReducer from "./imagesReducer";
import userReducer from "./userReducer";
export default combineReducers({
  drawnImage: drawnImageReducer,
  images: imagesReducer,
  user: userReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js